import React, {useState} from 'react';
import {Card, Nav, Tab} from 'react-bootstrap';
import HelpTextBlock from '@/components/help_text/HelpTextBlock';
import i18n from 'i18n';
import OutboundNotificationLogsDashboardView from '@/views/admin/notification/OutboundNotificationLogsDashboardView';
import OutboundNotificationLogsView from '@/views/admin/notification/OutboundNotificationLogsView';

const OutboundNotificationLogsHubView: React.FC = React.memo(() => {
    const [tab, setTab] = useState<string>('dashboard');

    return (
        <>
            <HelpTextBlock helpText={i18n.t('outbound_log_help.text')} />
            <Card className="mb-3">
                <Card.Body className="pb-3">
                    <Tab.Container id="outbound-notification-logs-hub" activeKey={tab} onSelect={(k) => setTab(k ?? 'dashboard')}>
                        <Nav variant="tabs" className="mb-3 d-flex flex-wrap">
                            <Nav.Item>
                                <Nav.Link className="custom-tabs" eventKey="dashboard">
                                    {i18n.t('outbound_log_tab_dashboard.text')}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link className="custom-tabs" eventKey="notifications">
                                    {i18n.t('outbound_log_tab_notifications.text')}
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content>
                            <Tab.Pane eventKey="dashboard">
                                <OutboundNotificationLogsDashboardView />
                            </Tab.Pane>
                            <Tab.Pane eventKey="notifications">
                                <OutboundNotificationLogsView hideHelpText />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Card.Body>
            </Card>
        </>
    );
});

OutboundNotificationLogsHubView.displayName = 'OutboundNotificationLogsHubView';

export default OutboundNotificationLogsHubView;
